import { render } from "./Items.vue?vue&type=template&id=22adce3d"
import script from "./Items.vue?vue&type=script&lang=js"
export * from "./Items.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Goya/components/Product/Items.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22adce3d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22adce3d', __exports__)) {
    api.reload('22adce3d', __exports__)
  }
  
  module.hot.accept("./Items.vue?vue&type=template&id=22adce3d", () => {
    api.rerender('22adce3d', render)
  })

}


export default __exports__